import { LoginResponseDTO } from '../domain/authentication.dto'
import { OfferDataResponseDTO } from '../domain/offerData.dto'
import { OfferData } from '../domain/offerData.model'
import {
  OfferDocumentDTO,
  OfferDocumentResponseDTO,
  OfferListResponseDTO,
  OfferPriceResponseDTO,
} from '../domain/offerDocument.dto'
import apiClient from '../infraestructure/apiClient'
import {
  getDefaultSelectedLanguage,
  getOfferDocumentId,
} from '../services/storage.service'

export const initOfferPath = `/offerDocument/bootStrap`
export const offerDocumentRootPath = `/offerDocument/${getOfferDocumentId()}`

export default {
  initOffer: function () {
    return apiClient.get<LoginResponseDTO>(initOfferPath)
  },

  getOffersList: async function (page?: number, pageSize?: number) {
    let paginationCondition = Boolean(page >= 0 && pageSize > 0)
      ? `?itemsPerPage=${pageSize}&page=${page}`
      : ''

    const offerList = await apiClient.get<OfferListResponseDTO>(
      `offerDocument/notExpired${paginationCondition}`,
    )

    return {
      notExpiredOffers: offerList.data,
      pagination: offerList.pagination,
    }
  },

  getPoliciesList: async function (page?: number, pageSize?: number) {
    let paginationCondition = Boolean(page >= 0 && pageSize > 0)
      ? `?itemsPerPage=${pageSize}&page=${page}`
      : ''

    const offerList = await apiClient.get<OfferListResponseDTO>(
      `offerDocument/contracted${paginationCondition}`,
    )

    return {
      policies: offerList.data,
      pagination: offerList.pagination,
    }
  },

  getExpiredOffersList: async function (page?: number, pageSize?: number) {
    let paginationCondition = Boolean(page >= 0 && pageSize > 0)
      ? `?itemsPerPage=${pageSize}&page=${page}`
      : ''

    const offerList = await apiClient.get<OfferListResponseDTO>(
      `offerDocument/expired${paginationCondition}`,
    )

    return {
      expired: offerList.data,
      pagination: offerList.pagination,
    }
  },

  getOfferDocument: function (id?: string) {
    const path = id
      ? `/offerDocument/${id}`
      : `/offerDocument/${getOfferDocumentId()}`
    return apiClient.get<OfferDocumentResponseDTO>(path)
  },

  getOfferData: function () {
    return apiClient.get<OfferDataResponseDTO>(
      `/offerDocument/${getOfferDocumentId()}/offerData`,
    )
  },

  getOfferPrice: function () {
    return apiClient.get<OfferPriceResponseDTO>(
      `/offerDocument/${getOfferDocumentId()}/price`,
    )
  },

  getOfferPDF: async function (offerId: string) {
    const lang = getDefaultSelectedLanguage()
    const pdf = await apiClient.get(
      `offerDocument/${offerId}/pdf?lang=${lang}`,
      {
        responseType: 'arraybuffer',
      },
    )

    return pdf as ArrayBuffer
  },

  putOfferData: function (offer: OfferData) {
    return apiClient.put<OfferDataResponseDTO>(
      `/offerDocument/${getOfferDocumentId()}/offerData`,
      offer,
    )
  },

  putOfferDocument: function (document: OfferDocumentDTO) {
    return apiClient.put<OfferDocumentResponseDTO>(
      `/offerDocument/${getOfferDocumentId()}`,
      document,
    )
  },

  constract: function () {
    const lang = getDefaultSelectedLanguage()
    return apiClient.post(
      `/offerDocument/${getOfferDocumentId()}/contract?lang=${lang}`,
    )
  },

  saveAndRetrieve: function () {
    const lang = getDefaultSelectedLanguage()
    return apiClient.post(
      `/offerDocument/${getOfferDocumentId()}/saveAndRetrieve?lang=${lang}`,
    )
  },

  sendOfferByEmail: function (offerId: string) {
    const lang = getDefaultSelectedLanguage()
    return apiClient.post(
      `/offerDocument/${offerId}/sendByEmailToCustomer?lang=${lang}`,
    )
  },

  setOfferAsDiscarded: function (offerId: string) {
    return apiClient.post<OfferDataResponseDTO>(
      `/offerDocument/${offerId}/discard`,
    )
  },
}
